import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const adapterDateFns = new AdapterDateFns();

export const { formats } = adapterDateFns;
